exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-08b76352]{position:absolute;top:5px;left:5px;z-index:1;height:40px;width:40px;background:#ededed;box-shadow:2px 2px 2px rgba(0,0,0,.1);border-radius:5px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.badge_right[data-v-08b76352]{left:unset;right:5px}.badge__count[data-v-08b76352]{font-weight:700;font-size:16px}.badge__text[data-v-08b76352]{font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08b76352","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/competences/card/components/badge/Badge.vue
// module id = f33eed2fd129cb3b19b4
// module chunks = 0